import { lazy, Suspense } from "react";

import { Skeleton } from "@aviary";

const StrictMapAgreement = lazy(() => import("./StrictMapAgreement"));

import type { Props } from "./StrictMapAgreement";

import * as styles from "./StrictMapAgreement.styles";

const LazyStrictMapAgreement = ({ ...rest }: Props) => {
  const fallback = (
    <div css={styles.skeleton} data-testid="skeleton">
      <Skeleton type="button" isFullWidth />
      <Skeleton type="button" isFullWidth css={styles.skeleton} />
    </div>
  );

  return (
    <Suspense fallback={fallback}>
      <StrictMapAgreement {...rest} />
    </Suspense>
  );
};

export { LazyStrictMapAgreement };
